import styled from 'styled-components';

export const Label = styled.span`
  border-radius: 4px;
  background-color: ${props => props.backgroundColor || `#eceff5`};
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  color: ${props => props.color || `#2d2d2d`};
  display: block;
  padding: 8px 10px;
`;
